import { jsx as _jsx } from "react/jsx-runtime";
import { useIsClient } from '@yonderland/andes-react';
import { useDispatch, useSelector } from 'react-redux';
import InStoreFilter from '../../components/lister/filters/in-store-filter/InStoreFilter';
import { analyticsActions } from '../../redux/analytics/actions/AnalyticsActions.creators';
import { basketActions } from '../../redux/basket/actions/BasketActions.creators';
import { listerActions } from '../../redux/lister/actions/ListerActions.creators';
import { makeGetInStoreFilterState } from '../../redux/lister/selectors/ListerSelector';
import { urlActions } from '../../redux/url/actions/UrlActions.creators';
import { makeGetStoreId } from '../../redux/url/selectors/UrlSelectors';
import ZendeskWidgetUtil from '../../util/ZendeskWidgetUtil';
const InStoreFilterContainer = () => {
    const dispatch = useDispatch();
    const inStoreFilter = useSelector(makeGetInStoreFilterState());
    const activeStoreId = useSelector(makeGetStoreId());
    const isClient = useIsClient();
    const openInStoreFilterPopup = () => {
        dispatch(basketActions.createCCPopupOpenAction());
        dispatch(inStoreFilter ? analyticsActions.storeFilterModified() : analyticsActions.storeFilterStarted());
        ZendeskWidgetUtil.updateZIndex(1);
    };
    const handleUpdateStoreId = (storeId) => {
        dispatch(urlActions.updateStoreId(storeId));
        if (!activeStoreId) {
            dispatch(analyticsActions.storeFilterApplied());
        }
    };
    if (!isClient)
        return null;
    return (_jsx(InStoreFilter, { inStoreFilter: inStoreFilter, activeStoreId: activeStoreId, handleOpenPopup: openInStoreFilterPopup, updateStoreId: handleUpdateStoreId, updateInStoreFilter: store => dispatch(listerActions.updateInStoreFilter(store)) }));
};
export default InStoreFilterContainer;
